<template>
  <div :class="main_class" :id="`game_${this.game.id}`">
    <div class="card_image" :style="style" @mouseover="mouseOver()" @mouseout="mouseOut()" @click="onClick()">
        <!--<img :src="img"/>-->
    </div>
    <div class="game_name" :style="gameNameDisplay" @mouseover="mouseOver()" @mouseout="mouseOut()" @click="onClick()">
        <span>{{ game.game }}</span>
    </div>
    <!-- <GameInfo :game="game" :visible="this.clicked"/> -->
  </div>
</template>

<script>
  import data from '../data'
  // import GameInfo from './GameInfo.vue'
  import { EventBus } from '../EventBus.js'
  
  export default {
    /* components: {
      GameInfo
    }, */
    props: { game: {
      type: Object,
      required: true
    }},
    computed: {
      gameNameDisplay () {
        if (!this.hovering) {
          return 'display: none;'
        }
        return ''
      },
      main_class () {
        return this.game.size + ' card tooltip-target'
      },
      style () {
        var w = this.game.width * (this.hovering ? 0.5 : 1)
        var h = this.game.height * (this.hovering ? 0.5 : 1)
        var maxsize = 150
        if (this.game.size === 'box2') {
          maxsize = 300
        } else if (this.game.size === 'box3') {
          maxsize = 450
        }
        if (h < maxsize) {
          var factor = maxsize / this.game.height
          h = maxsize
          w = this.game.width * factor
        }
        return { backgroundImage: `url(${this.game.img})`, backgroundPosition: `${this.game.posx}% ${this.game.posy}%`, backgroundSize: `${w}px ${h}px`, transition: `all 0.5s` }
      }
    },
    methods: {
      mouseOver (arg) {
        this.hovering = true
      },
      mouseOut () {
        this.hovering = false
      },
      onClick () {
        this.clicked = !this.clicked
        var rect = this.$el.getBoundingClientRect()
        var width = document.documentElement.clientWidth
        EventBus.$emit('game-clicked', { game: this.game, left: rect.right > width / 2 })
      }
    },
    mounted () {
      EventBus.$on('game-unclicked', dat => {
        if (dat.game === this.game) {
          this.onClick()
        }
      })
    },
    data () {
      return {
        clicked: false,
        hovering: false,
        platforms: data.platforms
      }
    }
  }
</script>


<style>
    .card {
        margin: 8px;
        position: relative;
    }
    .box1 {
        width: 150px;
        height: 150px;
        /*flex-grow: 1;*/
    }
    .box2 {
        width: 316px;
        height: 316px;
        /*flex-grow: 2;*/
    }
    .box3 {
        width: 482px;
        height: 482px;
        /*flex-grow: 3;*/
    }
    .card_image {
        width: 100%;
        height: 100%;
        background-color: black; /* fallback color */
        border-radius: 10px 10px;
        box-shadow: 5px 5px 0px rgba(221, 90, 13, 0.25);
    }
    .card_image:hover {
        background-size: 100px 100px;
        cursor: pointer;
    }
    .game_name {
        background-color: rgba(50, 50, 50, 0.5);
        position: absolute;
        width: 100%;
        bottom: 0px;
        height: 40px;
        vertical-align: middle;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0px 0px 10px 10px;
    }
    .game_name:hover {
        cursor: pointer;
    }
</style>
<style>
    a {
        color: #dd5a0d;
    }
    a:hover {
        color: #b20e0e;
    }
</style>



// WEBPACK FOOTER //
// src/components/GameCard.vue